import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { SvgIcon } from "@skylead/component-library"
import classNames from "classnames"
import React from "react"

const SortableHeader = ({ column, children, sort, onSort }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: column.key,
  })

  const sortIconClass = classNames("sort-item-icon", {
    active: sort,
    fliped: sort === "DESC",
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: isDragging ? "grabbing" : "grab",
    position: "sticky",
    top: 0,
    backgroundColor: "var(--surface-secondary)",
    zIndex: 25,
  }

  const handleHeaderClick = () => {
    if (column.sortable && onSort) {
      onSort(column)
    }
  }

  return (
    <th
      ref={setNodeRef}
      style={{
        width: column.width || "auto",
        minWidth: column.width || "auto",
        maxWidth: column.width || "none",
        ...style,
      }}
      className={`small-bold ${column.className || ""} ${column.sortable ? "sortable-header" : ""}`}
      {...attributes}
      {...listeners}
      onClick={handleHeaderClick}
    >
      {children}
      {column.sortable && <SvgIcon icon="arrow-narrow-down-16" className={sortIconClass} />}
    </th>
  )
}

export default SortableHeader
